import { signInWithRedirect } from 'aws-amplify/auth';

const Login = () => {
    signInWithRedirect();
    return (<></>)
};

export default Login;
